// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-TravelerDetails-TravelPolicy-styles___paper--xzlFp {
  padding: 32px;
  max-width: 736px;
  margin: 0 auto 30px;
  margin-left: 0;
}

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs {
    padding: 18px;
  }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs h2 {
      margin-bottom: 15px;
      font-size: 17px;
      color: #1b2432;
      letter-spacing: 0;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC {
      font-size: 15px !important;
      color: #1b2432;
      letter-spacing: 0;
      min-width: 155px;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC:first-child {
        line-height: 13px;
        max-width: 320px;
      }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN {
        display: flex;
      }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN .components-TravelerDetails-TravelPolicy-styles___avatarContainer--FJKNq {
          margin-right: 8px;
        }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN .components-TravelerDetails-TravelPolicy-styles___avatarContainer--FJKNq .components-TravelerDetails-TravelPolicy-styles___avatar--gxJzn {
            width: 50px;
            height: 50px;
          }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN .components-TravelerDetails-TravelPolicy-styles___avatarContainer--FJKNq .components-TravelerDetails-TravelPolicy-styles___avatarLetter--kCgRi {
            width: 50px;
            height: 50px;
            font-size: 15px;
            color: #6d717a;
            letter-spacing: 0;
            text-align: center;
            background-color: #e0e2e6;
            text-transform: uppercase;
          }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN .components-TravelerDetails-TravelPolicy-styles___name--AiDVZ {
          margin-bottom: 8px;
          margin-top: 8px;
          font-size: 15px;
          color: #1b2432;
          letter-spacing: 0;
        }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN .components-TravelerDetails-TravelPolicy-styles___email--Sth1C {
          font-size: 13px;
          color: #6d717a;
          letter-spacing: 0;
          font-weight: 400;
          line-height: 18px;
        }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___description--cNwN7::before {
        content: '\\A';
        white-space: pre;
      }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC .components-TravelerDetails-TravelPolicy-styles___description--cNwN7 {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 18px;
      }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___header--rgthx {
      font-size: 17px !important;
      color: #6d717a;
      letter-spacing: 0;
      text-align: center;
      font-weight: normal;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCellStyle--d7lm1 {
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 600;
      text-align: center;
      max-width: 250px;
      white-space: normal;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableCellStyle--d7lm1:first-letter {
      text-transform: uppercase;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ {
      height: 108px !important;
      vertical-align: center;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableRowApprovers--koMzA {
      height: 89px !important;
      vertical-align: center;
    }

  .components-TravelerDetails-TravelPolicy-styles___paper--xzlFp .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs .components-TravelerDetails-TravelPolicy-styles___tableRowApprovers--koMzA:last-child .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC {
          border-bottom: none;
        }

.components-TravelerDetails-TravelPolicy-styles___inputContainer--sBL6R {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.components-TravelerDetails-TravelPolicy-styles___inputWrapper--vcTQA {
  flex: 49% 0 1;
  padding: 8px 0 0;
}

.components-TravelerDetails-TravelPolicy-styles___table--qhbhy {
  margin: 20px 0 0;
}

.components-TravelerDetails-TravelPolicy-styles___tableHead--c9_jv {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ {
  height: 108px !important;
}

.components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ:last-child .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC {
      border: none;
    }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC {
  font-size: 15px !important;
  padding: 16px 56px 16px 24px !important;
}

.components-TravelerDetails-TravelPolicy-styles___emptyData--lYSvt {
  padding: 24px 0;
}

.components-TravelerDetails-TravelPolicy-styles___table--qhbhy {
  margin: 20px 0 0;
}

.components-TravelerDetails-TravelPolicy-styles___emptyData--lYSvt {
  padding: 24px 0;
}

.components-TravelerDetails-TravelPolicy-styles___tableHead--c9_jv {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}

.components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ {
  height: 108px !important;
}

.components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ:last-child .components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC {
      border: none;
    }

.components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ.components-TravelerDetails-TravelPolicy-styles___addNewTableRow--NtsPt {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC {
  font-size: 15px !important;
  padding: 16px 30px 16px 24px !important;
}

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC:first-child {
    padding: 16px 30px 16px 0px !important;
  }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC.components-TravelerDetails-TravelPolicy-styles___buttonCell--nvEIN {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC.components-TravelerDetails-TravelPolicy-styles___buttonCell--nvEIN button {
      padding-left: 0;
      padding-right: 0;
    }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC.components-TravelerDetails-TravelPolicy-styles___inputTableCell--vBfRr {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC.components-TravelerDetails-TravelPolicy-styles___inputTableCell--vBfRr > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

.components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC.components-TravelerDetails-TravelPolicy-styles___buttonTableCell--rOZk7 {
    padding: 16px 0 !important;
    text-align: right;
    width: 160px;
  }

.components-TravelerDetails-TravelPolicy-styles___iOSBar--z5Toj,
.components-TravelerDetails-TravelPolicy-styles___iOSBarON--U1ZLR {
  border-radius: 35px;
  width: 72px;
  height: 32px;
  margin-top: -15px;
  background-color: #6d717a;
  opacity: 1;
  margin-left: -32px;
}

.components-TravelerDetails-TravelPolicy-styles___disabled--pXW7X + span {
  opacity: 0.12 !important;
}

.components-TravelerDetails-TravelPolicy-styles___iOSBar--z5Toj:before {
  content: attr(title) 'OFF';
  color: white;
  position: relative;
  top: 7px;
  right: 9px;
  font-size: 15px;
  letter-spacing: 0;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.components-TravelerDetails-TravelPolicy-styles___iOSBarON--U1ZLR:before {
  content: attr(title) 'ON';
  color: white;
  position: relative;
  top: 7px;
  left: -38px;
  font-size: 15px;
  letter-spacing: 0;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}

.components-TravelerDetails-TravelPolicy-styles___iOSIcon--t1t8j {
  width: 24px;
  height: 24px;
  background-color: white;
}

.components-TravelerDetails-TravelPolicy-styles___iOSIconChecked--hiUZp {
  boxshadow: theme.shadows[1];
  content: attr(title) 'ON';
}

.components-TravelerDetails-TravelPolicy-styles___iOSSwitchBase--x62gI .components-TravelerDetails-TravelPolicy-styles___iOSChecked--AoAOW {
    color: green;
  }

.components-TravelerDetails-TravelPolicy-styles___iOSSwitchBase--x62gI .components-TravelerDetails-TravelPolicy-styles___iOSChecked--AoAOW + \$iOSBar {
      background-color: red;
    }

.components-TravelerDetails-TravelPolicy-styles___iOSChecked--AoAOW {
  transform: translateX(35px);
  width: 38px !important;
}

.components-TravelerDetails-TravelPolicy-styles___iOSChecked--AoAOW + .components-TravelerDetails-TravelPolicy-styles___iOSBarON--U1ZLR {
    opacity: 1;
    background-color: '#318AFB';
    border: none;
  }

.components-TravelerDetails-TravelPolicy-styles___iOSChecked--AoAOW.components-TravelerDetails-TravelPolicy-styles___iOSBarON--U1ZLR {
    background-color: '#318AFB';
  }

.components-TravelerDetails-TravelPolicy-styles___colorPrimary--JSaJZ {
  color: #318afb;
  width: 31px;
  margin-top: 1px;
}

.components-TravelerDetails-TravelPolicy-styles___loaderWrapper--_1EwP {
  position: relative;
}

.components-TravelerDetails-TravelPolicy-styles___pageWrapper--te_Yw {
  border: 0px;
}

.components-TravelerDetails-TravelPolicy-styles___loading--M3k1z {
  background: #f6f6f7;
  pointer-events: none;
}

.components-TravelerDetails-TravelPolicy-styles___loading--M3k1z .components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs {
    background: #f6f6f7;
    pointer-events: none;
  }

.components-TravelerDetails-TravelPolicy-styles___approversPaper--WjsQO {
  width: 354px;
  margin-right: 0;
  margin-left: 30px !important;
}
`, "",{"version":3,"sources":["webpack://./components/TravelerDetails/TravelPolicy/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAgHhB;;EA9GE;IACE,aAAa;EA4Gf;;EA1GE;MACE,mBAAmB;MACnB,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;EAEA;MACE,0BAA0B;MAC1B,cAAc;MACd,iBAAiB;MACjB,gBAAgB;IAwDlB;;EAvDE;QACE,iBAAiB;QACjB,gBAAgB;MAClB;;EAEA;QACE,aAAa;MAmCf;;EAjCE;UACE,iBAAiB;QAiBnB;;EAfE;YACE,WAAW;YACX,YAAY;UACd;;EAEA;YACE,WAAW;YACX,YAAY;YACZ,eAAe;YACf,cAAc;YACd,iBAAiB;YACjB,kBAAkB;YAClB,yBAAyB;YACzB,yBAAyB;UAC3B;;EAEF;UACE,kBAAkB;UAClB,eAAe;UACf,eAAe;UACf,cAAc;UACd,iBAAiB;QACnB;;EACA;UACE,eAAe;UACf,cAAc;UACd,iBAAiB;UACjB,gBAAgB;UAChB,iBAAiB;QACnB;;EAGF;QACE,aAAa;QACb,gBAAgB;MAClB;;EAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,iBAAiB;MACnB;;EAGF;MACE,0BAA0B;MAC1B,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,mBAAmB;IACrB;;EAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;IACrB;;EAEA;MACE,yBAAyB;IAC3B;;EAEA;MACE,wBAAwB;MACxB,sBAAsB;IACxB;;EAEA;MACE,uBAAuB;MACvB,sBAAsB;IAOxB;;EAJI;UACE,mBAAmB;QACrB;;AAMR;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAO1B;;AAJI;MACE,YAAY;IACd;;AAIJ;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAW1B;;AARI;MACE,YAAY;IACd;;AAGF;IACE,+CAA+C;EACjD;;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AA+BzC;;AA9BE;IACE,sCAAsC;EACxC;;AAEA;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EAMd;;AAJE;MACE,eAAe;MACf,gBAAgB;IAClB;;AAGF;IACE,oCAAoC;IACpC,YAAY;EAMd;;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;;AAGF;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;EACd;;AAGF;;EAEE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAGE;IACE,YAAY;EAId;;AAHE;MACE,qBAAqB;IACvB;;AAIJ;EACE,2BAA2B;EAC3B,sBAAsB;AAMxB;;AALE;IACE,UAAU;IACV,2BAA2B;IAC3B,YAAY;EACd;;AAIA;IACE,2BAA2B;EAC7B;;AAGF;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AAMtB;;AAJE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;AAGF;EACE,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 auto 30px;\n  margin-left: 0;\n\n  .policyRules {\n    padding: 18px;\n\n    h2 {\n      margin-bottom: 15px;\n      font-size: 17px;\n      color: #1b2432;\n      letter-spacing: 0;\n    }\n\n    .tableCell {\n      font-size: 15px !important;\n      color: #1b2432;\n      letter-spacing: 0;\n      min-width: 155px;\n      &:first-child {\n        line-height: 13px;\n        max-width: 320px;\n      }\n\n      .avatarAndName {\n        display: flex;\n\n        .avatarContainer {\n          margin-right: 8px;\n\n          .avatar {\n            width: 50px;\n            height: 50px;\n          }\n\n          .avatarLetter {\n            width: 50px;\n            height: 50px;\n            font-size: 15px;\n            color: #6d717a;\n            letter-spacing: 0;\n            text-align: center;\n            background-color: #e0e2e6;\n            text-transform: uppercase;\n          }\n        }\n        .name {\n          margin-bottom: 8px;\n          margin-top: 8px;\n          font-size: 15px;\n          color: #1b2432;\n          letter-spacing: 0;\n        }\n        .email {\n          font-size: 13px;\n          color: #6d717a;\n          letter-spacing: 0;\n          font-weight: 400;\n          line-height: 18px;\n        }\n      }\n\n      .description::before {\n        content: '\\A';\n        white-space: pre;\n      }\n\n      .description {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n        font-weight: 400;\n        line-height: 18px;\n      }\n    }\n\n    .header {\n      font-size: 17px !important;\n      color: #6d717a;\n      letter-spacing: 0;\n      text-align: center;\n      font-weight: normal;\n    }\n\n    .tableCellStyle {\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 600;\n      text-align: center;\n      max-width: 250px;\n      white-space: normal;\n    }\n\n    .tableCellStyle:first-letter {\n      text-transform: uppercase;\n    }\n\n    .tableRow {\n      height: 108px !important;\n      vertical-align: center;\n    }\n\n    .tableRowApprovers {\n      height: 89px !important;\n      vertical-align: center;\n\n      &:last-child {\n        .tableCell {\n          border-bottom: none;\n        }\n      }\n    }\n  }\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 108px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 56px 16px 24px !important;\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 108px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 30px 16px 24px !important;\n  &:first-child {\n    padding: 16px 30px 16px 0px !important;\n  }\n\n  &.buttonCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right;\n    width: 160px;\n  }\n}\n\n.iOSBar,\n.iOSBarON {\n  border-radius: 35px;\n  width: 72px;\n  height: 32px;\n  margin-top: -15px;\n  background-color: #6d717a;\n  opacity: 1;\n  margin-left: -32px;\n}\n\n.disabled + span {\n  opacity: 0.12 !important;\n}\n\n.iOSBar:before {\n  content: attr(title) 'OFF';\n  color: white;\n  position: relative;\n  top: 7px;\n  right: 9px;\n  font-size: 15px;\n  letter-spacing: 0;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.iOSBarON:before {\n  content: attr(title) 'ON';\n  color: white;\n  position: relative;\n  top: 7px;\n  left: -38px;\n  font-size: 15px;\n  letter-spacing: 0;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.iOSIcon {\n  width: 24px;\n  height: 24px;\n  background-color: white;\n}\n.iOSIconChecked {\n  boxshadow: theme.shadows[1];\n  content: attr(title) 'ON';\n}\n\n.iOSSwitchBase {\n  & .iOSChecked {\n    color: green;\n    & + $iOSBar {\n      background-color: red;\n    }\n  }\n}\n\n.iOSChecked {\n  transform: translateX(35px);\n  width: 38px !important;\n  & + .iOSBarON {\n    opacity: 1;\n    background-color: '#318AFB';\n    border: none;\n  }\n}\n\n.iOSChecked {\n  &.iOSBarON {\n    background-color: '#318AFB';\n  }\n}\n\n.colorPrimary {\n  color: #318afb;\n  width: 31px;\n  margin-top: 1px;\n}\n\n.loaderWrapper {\n  position: relative;\n}\n\n.pageWrapper {\n  border: 0px;\n}\n\n.loading {\n  background: #f6f6f7;\n  pointer-events: none;\n\n  .policyRules {\n    background: #f6f6f7;\n    pointer-events: none;\n  }\n}\n\n.approversPaper {\n  width: 354px;\n  margin-right: 0;\n  margin-left: 30px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-TravelerDetails-TravelPolicy-styles___paper--xzlFp`,
	"policyRules": `components-TravelerDetails-TravelPolicy-styles___policyRules--QkFJs`,
	"tableCell": `components-TravelerDetails-TravelPolicy-styles___tableCell--aYiGC`,
	"avatarAndName": `components-TravelerDetails-TravelPolicy-styles___avatarAndName--WDhPN`,
	"avatarContainer": `components-TravelerDetails-TravelPolicy-styles___avatarContainer--FJKNq`,
	"avatar": `components-TravelerDetails-TravelPolicy-styles___avatar--gxJzn`,
	"avatarLetter": `components-TravelerDetails-TravelPolicy-styles___avatarLetter--kCgRi`,
	"name": `components-TravelerDetails-TravelPolicy-styles___name--AiDVZ`,
	"email": `components-TravelerDetails-TravelPolicy-styles___email--Sth1C`,
	"description": `components-TravelerDetails-TravelPolicy-styles___description--cNwN7`,
	"header": `components-TravelerDetails-TravelPolicy-styles___header--rgthx`,
	"tableCellStyle": `components-TravelerDetails-TravelPolicy-styles___tableCellStyle--d7lm1`,
	"tableRow": `components-TravelerDetails-TravelPolicy-styles___tableRow--_LlYQ`,
	"tableRowApprovers": `components-TravelerDetails-TravelPolicy-styles___tableRowApprovers--koMzA`,
	"inputContainer": `components-TravelerDetails-TravelPolicy-styles___inputContainer--sBL6R`,
	"inputWrapper": `components-TravelerDetails-TravelPolicy-styles___inputWrapper--vcTQA`,
	"table": `components-TravelerDetails-TravelPolicy-styles___table--qhbhy`,
	"tableHead": `components-TravelerDetails-TravelPolicy-styles___tableHead--c9_jv`,
	"emptyData": `components-TravelerDetails-TravelPolicy-styles___emptyData--lYSvt`,
	"addNewTableRow": `components-TravelerDetails-TravelPolicy-styles___addNewTableRow--NtsPt`,
	"buttonCell": `components-TravelerDetails-TravelPolicy-styles___buttonCell--nvEIN`,
	"inputTableCell": `components-TravelerDetails-TravelPolicy-styles___inputTableCell--vBfRr`,
	"buttonTableCell": `components-TravelerDetails-TravelPolicy-styles___buttonTableCell--rOZk7`,
	"iOsBar": `components-TravelerDetails-TravelPolicy-styles___iOSBar--z5Toj`,
	"iOsBarOn": `components-TravelerDetails-TravelPolicy-styles___iOSBarON--U1ZLR`,
	"disabled": `components-TravelerDetails-TravelPolicy-styles___disabled--pXW7X`,
	"iOsIcon": `components-TravelerDetails-TravelPolicy-styles___iOSIcon--t1t8j`,
	"iOsIconChecked": `components-TravelerDetails-TravelPolicy-styles___iOSIconChecked--hiUZp`,
	"iOsSwitchBase": `components-TravelerDetails-TravelPolicy-styles___iOSSwitchBase--x62gI`,
	"iOsChecked": `components-TravelerDetails-TravelPolicy-styles___iOSChecked--AoAOW`,
	"colorPrimary": `components-TravelerDetails-TravelPolicy-styles___colorPrimary--JSaJZ`,
	"loaderWrapper": `components-TravelerDetails-TravelPolicy-styles___loaderWrapper--_1EwP`,
	"pageWrapper": `components-TravelerDetails-TravelPolicy-styles___pageWrapper--te_Yw`,
	"loading": `components-TravelerDetails-TravelPolicy-styles___loading--M3k1z`,
	"approversPaper": `components-TravelerDetails-TravelPolicy-styles___approversPaper--WjsQO`
};
module.exports = ___CSS_LOADER_EXPORT___;
